<template>
  <v-dialog
    v-model="visible"
    persistent
    fullscreen
    hide-overlay
    content-class="acceso-bloqueado-dialog"
  >
    <div class="acceso-bloqueado-overlay d-flex align-center justify-center">
      <v-card class="acceso-bloqueado-card text-center pa-8" max-width="640" elevation="12">
        <v-icon color="error" size="96" class="mb-4">mdi-shield-lock</v-icon>
        <div class="text-h4 font-weight-bold error--text mb-4">
          Acceso denegado
        </div>
        <div class="text-h6 grey--text text--darken-2 mb-4">
          Favor de comunicarse con su jefe directo
        </div>
        <div class="text-body-1 font-weight-medium mb-2">
          Tu acceso ha sido temporalmente bloqueado por el siguiente motivo:
        </div>
        <div class="text-h6 error--text font-weight-bold px-4">
          {{ motivo || 'Sin motivo especificado' }}
        </div>
        <div class="text-body-2 grey--text mt-6">
          Esta pantalla se cerrará automáticamente cuando tu jefe lo desbloquee.
        </div>
      </v-card>
    </div>
  </v-dialog>
</template>

<script>
export default {
  name: 'AlertaAccesoBloqueado',
  props: {
    estatus: {
      type: Boolean,
      default: false,
    },
    motivo: {
      type: String,
      default: '',
    },
  },
  computed: {
    visible: {
      get() {
        return this.estatus
      },
      set() {
        // No se puede cerrar desde el cliente; solo el desbloqueo lo quita
      },
    },
  },
}
</script>

<style scoped>
.acceso-bloqueado-overlay {
  min-height: 100vh;
  width: 100%;
  background: rgba(20, 20, 20, 0.92);
  padding: 24px;
}
.acceso-bloqueado-card {
  border-radius: 12px !important;
  border-top: 6px solid #d32f2f;
}
</style>

<style>
.acceso-bloqueado-dialog {
  box-shadow: none !important;
  background: transparent !important;
}
</style>
